import type * as Api from 'src/api'

/**
 * Row tint per statement status, the same on the admin list and the student's own list in old Argus:
 * pending none, declined red, accepted green, partial yellow.
 */
export const STATEMENT_STATUS_ROW_CLASSES: Readonly<Record<number, string>> = {
  2: 'bg-lightRed',
  3: 'bg-lightGreen',
  4: 'bg-lightYellow',
}

const STATUS_IDS: Readonly<Record<Api.StatementStatusEnum, number>> = {
  STATUS_PENDING: 1,
  STATUS_DECLINED: 2,
  STATUS_ACCEPTED: 3,
  STATUS_PARTIAL: 4,
}

export function statementStatusRowClass(status: Api.StatementStatusEnum): string | undefined {
  return STATEMENT_STATUS_ROW_CLASSES[STATUS_IDS[status]]
}
